export const FORM_FIELDS = {
  LANGUAGE: 'language',
  HEADLINE: 'headline',
  URL: 'url',
  PLATFORM: 'platform',
  PRODUCT: 'product',
  CLIENT: 'client',
  SECTIONS: 'sections',
  INTERNAL_INFORMATION: 'internal_information',
  LIVE_URLS: 'live_urls',
  CONTENT_IDS: 'content_ids',
  ARTICLE_VERSION_LIST: 'article_version_list',
  NEXT_STATES: 'next_states',
  SURTITLES: 'surtitles',
  TOPICS: 'topics',
  TOPICS_WITH_TRANSLATIONS: 'topics_with_translations',
  TAGS: 'tags',
  COMPANIES: 'companies',
  PEOPLE: 'people',
  PUBLISH: 'publish',
  DATE: 'date',
  TIMEZONE: 'timezone',
  SHOW_PUBLISH_TIME: 'show_publish_time',
  SELECTED_AUTHORS: 'selected_authors',
  RELATED_MANAGERS: 'related_managers',
  RELATED_FUNDS: 'related_funds',
  RELATED_SECTORS: 'related_sectors',
  RELATED_ASSET_CLASSES: 'related_asset_classes',
  RELATED_ETFS: 'related_etfs',
  RELATED_INVESTMENT_TRUSTS: 'related_investment_trusts',
  RELATED_SHARES: 'related_shares',
};
